import { render, staticRenderFns } from "./ConfigManager.vue?vue&type=template&id=21ced55a&scoped=true"
import script from "./ConfigManager.vue?vue&type=script&lang=js"
export * from "./ConfigManager.vue?vue&type=script&lang=js"
import style0 from "./ConfigManager.vue?vue&type=style&index=0&id=21ced55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ced55a",
  null
  
)

export default component.exports